<!-- 
  デザイン編集領域
-->
<template>
  <!-- <div class="maincanvas overflow-auto"> -->
  <div class="h-100 w-100" style="position: relative;" :style="backGroundColor">
    <!-- <div class="container canvassize" v-if="this.$store.state.currentCanvasData">
      <div class="border border-dark m-0 p-0" style="width: 230px">
        <p class="pt-1 pb-0 mb-0" style="letter-spacing: 0.2em">最大キャンバスサイズ</p>
        <p class="pt-1 pb-0 mb-0">
          {{ this.$store.state.currentCanvasData.canvasSize.width }}px
          <span class="px-3">x</span>
          {{ this.$store.state.currentCanvasData.canvasSize.height }}px
        </p>
      </div>
      <div class="border border-dark m-0 p-0 mt-2" style="width: 230px">
        <small class="pt-1 pb-0 mb-0" style="color: rgba(130, 130, 130, 1)"
          >納期目安(500枚以内):{{ this.deliveryDate }}</small
        >
      </div>
    </div> -->

    <!-- デザイン -->
    <div class="h-100 w-100 backgroundlayer" :class="{ zoom: this.$store.state.isZoom }">
      <img v-bind:src="this.backgroundImagePath" />
    </div>

    <!-- カットライン -->
    <div class="h-100 w-100 backgroundlayer" :class="{ zoom: this.$store.state.isZoom }">
      <img v-bind:src="this.$store.state.frameCutlineImageURL" />
    </div>

    <div
      class="itemlayer w-100 h-100"
      style="overflow:hidden;position:relative;"
      v-on:click="clickAction"
      v-if="this.isReady"
      
    >
      <CanvasItem
        v-for="(item, index) in this.getItemList()"
        v-bind:itemData="item"
        v-bind:key="index"
      />
    </div>
    <!-- <div class="foregroundlayer" :class="{ zoom: this.$store.state.isZoom }">
      <img v-bind:src="this.getForegroundImagePath()" v-if="this.isReady" />
    </div> -->
    <canvas
      :class="{ zoom: this.$store.state.isZoom }"
      ref="alphalayer"
      class="alphalayer"
      width="700px"
      height="700px"
      v-show="!this.$store.state.isBorder"
      @dragenter="dragEnter"
    ></canvas>
    <canvas
      :class="{ zoom: this.$store.state.isZoom }"
      ref="gridlayer"
      class="gridlayer"
      width="700px"
      height="700px"
      v-show="isShowGrid"
    ></canvas>
    <!-- <div class="itemplus">
      <img
        src="@/assets/btn/add_image.png"
        v-on:click="plusAction"
        v-if="this.isReady && !this.$store.state.isZoom"
      />
    </div>
    <img
      class="reversebutton"
      src="@/assets/reverse.png"
      v-on:click="reverseAction"
      v-if="this.isReverse"
    /> -->
    <!-- <img
      class="tagplusbutton"
      src="@/assets/btn/tag_plus.png"
      v-on:click="tagPlusAction"
      v-if="this.isAddTag && !this.$store.state.isZoom"
    /> -->
    <!-- <div
      class="fullview text-light"
      v-if="isEnter"
      @dragleave="dragLeave"
      @dragover.prevent
      @drop.prevent="dropFile"
    >
      ドロップでアイテムを追加
    </div> -->
  </div>
</template>

<script>
import { PreviewColorList } from "@/js/Const.js";
import CanvasItem from "@/components/home/CanvasItem.vue";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

export default {
  name: "MainCanvas",
  props: {},
  data() {
    // 値を関数で宣言する
    // 関数で宣言しておくのが標準らしい
    return {
      alphaCanvas: null,
      alphaContext: null,
      gridCanvas: null,
      gridContext: null,
      isEnter: false,
      dropFiles: [],
      deliveryDate: "",
    };
  },
  created() {
    this.$store.commit("setMainCanvas", this);
    console.log("MainCanvas created");

    var ref = firebase.database().ref("DeliveryDate/");
    ref.on("value", (snapshot) => {
      /* ここに取得したデータを用いた何らかの処理 */
      this.deliveryDate = snapshot.val()["date"];
    });
  },
  mounted() {
    // 読み込まれる際の定義
    // refによってdiv内の要素を指定する
    this.alphaCanvas = this.$refs.alphalayer;
    this.alphaContext = this.alphaCanvas.getContext("2d");
    this.gridCanvas = this.$refs.gridlayer;
    this.gridContext = this.gridCanvas.getContext("2d");
    this.gridContext.scale(0.5, 0.5);
    console.log("MainCanvas Mounted");
  },
  computed: {
    isVideoShow() {
      if (this.$store.state.currentProduct) {
        return false;
      } else {
        return true;
      }
    },
    isShowGrid: function () {
      return !this.$store.state.isHiddenGrid;
    },
    isReady: function () {
      if (this.$store.state.currentCanvasData) {
        return true;
      } else {
        return false;
      }
    },
    isAddTag: function () {
      if (
        this.$store.state.currentCanvasData &&
        this.$store.state.currentProduct.tagInfo == "noTag"
      ) {
        if (this.$store.state.currentProduct.productId == "5") {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isReverse: function () {
      if (
        this.$store.state.currentCanvasData &&
        this.$store.state.currentProduct.canvasDatas.length == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    backgroundImagePath: function () {
      if (this.$store.state.currentCanvasData) {
        // this.updateAlphaLayer();
        // this.updateGridLayer();
        return this.$store.state.currentCanvasData.getBackgroundImagePath();
      } else {
        this.clearLayer();
        return require("@/assets/transparent.png");
        // return ""
      }
    },
    cutlineImagePath: function () {
      if (this.$store.state.currentCanvasData) {
        // this.updateAlphaLayer();
        // this.updateGridLayer();
        return this.$store.state.currentCanvasData.getCutlineImagePath();
      } else {
        this.clearLayer();
        return require("@/assets/transparent.png");
        // return ""
      }
    },
    backGroundColor(){
      return {
        "background-color":PreviewColorList[this.$store.state.selectBackgroundColor]
      }
    }
  },
  methods: {
    dropFile(event) {
      console.log(event);
      // console.log("dropFile");
      // let files = [...event.dataTransfer.files];
      // let errorMessage = [];
      // for (let f of files) {
      //   // let error = this.$store.state.currentCanvasData.addItem(f);
      //   let error = this.$store.state.currentCanvasData.addTextItem(
      //     "テキスト",
      //     "SmartUiFont",
      //     "left",
      //     "#000000"
      //   );
      //   console.log(f);
      //   if (error == "NOEXT") {
      //     if (!errorMessage.includes("対応ファイル形式はjpeg pngのみとなります")) {
      //       errorMessage.push("拡張子のないファイルは使用できません");
      //     }
      //   }
      //   if (error == "ERROR") {
      //     if (!errorMessage.includes("対応ファイル形式はjpeg pngのみとなります")) {
      //       errorMessage.push("対応ファイル形式はjpeg pngのみとなります");
      //     }
      //   }
      // }
      // if (errorMessage.length > 0) {
      //   let message = "";
      //   for (let msg of errorMessage) {
      //     message += msg;
      //     message += "@@@n";
      //   }
      //   this.$store.commit("showMessage", message);
      // }
      // this.isEnter = false;
    },
    dragLeave() {
      this.isEnter = false;
    },
    dragEnter() {
      if (this.isVideoShow) {
        return;
      }
      this.isEnter = true;
    },
    onloadeddata(ev) {
      ev.target.play();
    },
    getItemList: function () {
      if (this.$store.state.currentCanvasData) {
        return this.$store.state.currentCanvasData.itemList;
      } else {
        return [];
      }
    },
    getBackgroundImagePath() {
      if (this.$store.state.currentCanvasData) {
        this.updateAlphaLayer();
        this.updateGridLayer();
        return this.$store.state.currentCanvasData.getBackgroundImagePath();
      } else {
        this.clearLayer();
        return require("@/assets/defaultback.png");
      }
    },
    getForegroundImagePath() {
      if (this.$store.state.currentCanvasData) {
        return this.$store.state.currentCanvasData.getForegroundImagePath();
      } else {
        return "";
      }
    },
    getGridImagePath() {
      if (this.$store.state.currentCanvasData) {
        return "@/assets/grid.png";
      } else {
        return "";
      }
    },
    clickAction: function () {
      this.$store.state.currentCanvasData.setCurrentItem(null);
    },
    tagPlusAction: function () {
      this.$store.state.currentProduct.addTag();
    },
    reverseAction: function () {
      var cdata = this.$store.state.currentProduct.addCanvas();
      this.$store.commit("selectCanvasData", cdata);
    },
    updateAlphaLayer: function () {
      // アルファ画像も作成する
      this.alphaContext.clearRect(0, 0, 700, 700);
      this.alphaContext.strokeStyle = "rgba(80,80,80,1)";
      this.alphaContext.lineWidth = 1;
      this.alphaContext.strokeRect(
        this.$store.state.currentCanvasData.canvasScreenPosition.x,
        this.$store.state.currentCanvasData.canvasScreenPosition.y,
        this.$store.state.currentCanvasData.canvasScreenSize.width,
        this.$store.state.currentCanvasData.canvasScreenSize.height
      );
      this.alphaContext.strokeStyle = "rgba(150,150,150,1)";
      this.alphaContext.strokeRect(
        this.$store.state.currentCanvasData.canvasScreenPosition.x - 1,
        this.$store.state.currentCanvasData.canvasScreenPosition.y - 1,
        this.$store.state.currentCanvasData.canvasScreenSize.width + 2,
        this.$store.state.currentCanvasData.canvasScreenSize.height + 2
      );
      // this.alphaContext.fillStyle = "rgba(0,0,0,0.3)";
      // this.alphaContext.clearRect(0, 0, 700, 700);
      // this.alphaContext.fillRect(0, 0, 700, 700);
      // this.alphaContext.clearRect(
      //   this.$store.state.currentCanvasData.canvasScreenPosition.x,
      //   this.$store.state.currentCanvasData.canvasScreenPosition.y,
      //   this.$store.state.currentCanvasData.canvasScreenSize.width,
      //   this.$store.state.currentCanvasData.canvasScreenSize.height
      // );
    },
    updateGridLayer: function () {
      this.gridContext.clearRect(0, 0, 1400, 1400);
      if (this.$store.state.gridType == 1) {
        this.gridContext.strokeStyle = "rgba(80,80,80,0.7)";
      } else {
        this.gridContext.strokeStyle = "rgba(180,180,180,0.7)";
      }

      this.gridContext.beginPath();
      for (var x = 0; x < 120; x++) {
        this.gridContext.moveTo(14.3 * x, 0);
        this.gridContext.lineTo(14.3 * x, 1400);
      }
      for (var y = 0; y < 120; y++) {
        this.gridContext.moveTo(0, 14.3 * y);
        this.gridContext.lineTo(1400, 14.3 * y);
      }
      this.gridContext.stroke();
    },
    clearLayer: function () {
      if (this.gridContext) {
        this.gridContext.clearRect(0, 0, 1400, 1400);
      }
      if (this.alphaContext) {
        this.alphaContext.clearRect(0, 0, 700, 700);
      }
    },
    plusAction: function () {
      if (this.$store.state.sideTab && this.$store.state.sideTab.isOrderActive == true) {
        this.$store.state.sideTab.tabAction(1);
        return;
      }
      this.$store.state.layerVue.plusAction();
    },
    previewAction: function () {
      this.$store.commit("showLastPreview");
    },
    returnThis() {
      return this;
    },
    getQuantity: function(){
      return this.$store.state.currentProduct.quantity;
    },
  },
  components: {
    CanvasItem,
  },
  watch:{
    "$store.state.currentProduct.quantity"(newQuantity){
      if(this.$store.state.currentCanvasData) {
        this.$store.state.currentCanvasData.updateQuantity(newQuantity);
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.maincanvas {
  background-color: white;
  /* position: relative; */
}
.backgroundlayer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  /* left:50px;
  top:50px; */
  width: 569px;
  height: 700px;
}
.alphalayer,
.gridlayer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  pointer-events: none;
}
.gridlayer {
  top: 5px;
  left: 0px;
}
.backgroundlayer img,
.itemplus img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.foregroundlayer {
  z-index: 10;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  /* left:50px;
  top:50px; */
  width: 700px;
  height: 700px;
  pointer-events: none;
}
.itemplus {
  z-index: 20;
  position: absolute;
  left: 80%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 700px;
  /* left:50px;
  top:50px; */
  width: 70px;
  height: 70px;
}
.preview {
  z-index: 20;
  position: fixed;
  left: 60px;
  top: 70px;
  /* left:50px;
  top:50px; */
  width: 90px;
  height: 30px;
}
.reversebutton {
  z-index: 20;
  position: absolute;
  left: 20px;
  top: 300px;
  /* left:50px;
  top:50px; */
  width: 70px;
  height: 70px;
}
.tagplusbutton {
  z-index: 20;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 70px;
  /* left:50px;
  top:50px; */
  width: 70px;
  height: 70px;
}
.foregroundlayer img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.itemlayer {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  /* left:50px;
  top:50px; */
  width: 569px;
  height: 700px;
}
.dark {
  background-color: rgb(73, 73, 73);
}
.fullview {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: #00000077;
  display: flex;
  justify-content: center;
  align-items: center;
}
.canvassize {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 230px;
  height: 90px;
  z-index: 20;
}
.canvassize p {
  color: rgba(130, 130, 130, 1);
}
.zoom {
  transform-origin: 50% 30%;
  transform: scale(2);
}
</style>
